module.exports = ($scope, $uibModalInstance, projectPermissions, iteration, proximity, adverseTermsLists) ->
  $scope.config =
    adverseTerms: iteration.adverse_terms
    adverseTermsList: (list for list in adverseTermsLists when list.id == iteration.adverse_terms_list)[0] if iteration?.adverse_terms_list
    proximity: proximity

  $scope.projectPermissions = projectPermissions

  # This feeds the drop-down list of available adverse terms lists
  $scope.adverseTermsLists = (list for list in adverseTermsLists when list.is_latest_version)

  $scope.terms = {"adverseTermsSelector" : {}}

  # Called when the user selects a different list in the drop-down
  $scope.$watch 'terms.adverseTermsSelector', (value) ->
    if value?.word_list
      # Update the contents of the textbox
      $scope.config.adverseTerms = value['word_list']
      # Update the internal status so we have all the details to return
      $scope.config.adverseTermsList = value


  # Called when the user clicks Ok
  $scope.ok = () ->
    $uibModalInstance.close({
      adverseTerms: $scope.config.adverseTerms,
      adverseTermsList: $scope.config.adverseTermsList,
      proximity: $scope.config.proximity
    })

  $scope.cancel = () ->
    $uibModalInstance.dismiss('cancel')
